import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'app-checkout-upload-documents',
    standalone: true,
    imports: [CommonModule],
    templateUrl: './checkout-upload-documents.component.html',
    styleUrls: ['./checkout-upload-documents.component.scss']
})
export class CheckoutUploadDocumentsComponent implements OnInit {
    @Input() uploadedFiles: Record<string, File> = {};
    @Output() filesChanged = new EventEmitter<Record<string, File>>();

    /** Local copy to track current state including new selections */
    localFiles: Record<string, File> = {};
    fileErrors: Record<string, string> = {};

    ngOnInit(): void {
        // Initialize local state from parent input
        this.localFiles = { ...this.uploadedFiles };
    }

    onFileChange(key: string, event: Event): void {
        const input = event.target as HTMLInputElement;
        delete this.fileErrors[key];

        if (input.files?.length) {
            const file = input.files[0];
            const maxSize = 40 * 1024 * 1024; // 40MB

            if (file.size > maxSize) {
                this.fileErrors[key] = 'El archivo supera el límite de 40MB.';
                input.value = '';
                delete this.localFiles[key];
            } else {
                this.localFiles[key] = file;
            }
        } else {
            delete this.localFiles[key];
        }
        this.filesChanged.emit({ ...this.localFiles });
    }

    getFileName(key: string): string | null {
        return this.localFiles[key]?.name ?? null;
    }

    removeFile(key: string): void {
        delete this.localFiles[key];
        delete this.fileErrors[key];
        this.filesChanged.emit({ ...this.localFiles });
    }
}
